import SearchBox from "../../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import DisplayTable from "../../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../../common_nextgen/common_components/Modal/ConfirmationModal";
import useNonStateCostSourceAndType from "./hooks/useNonStateCostSourceAndType";

const NonStateCostSourceAndType = ({
  onSelect,
  hideModal,
  params,
  selectMode,
  lookupType,
  selectParamsData,
}) => {
  const nonStateCostSourceAndTypeData = useNonStateCostSourceAndType({
    onSelect,
    hideModal,
    params,
    selectMode,
    lookupType,
    selectParamsData,
  });

  return (
    <div class="container container-fluid">
      <ButtonsSection
        ctaButtons={nonStateCostSourceAndTypeData.leftButtons}
        align="left"
      />
      <div className="header-section">
        <h1>
          {nonStateCostSourceAndTypeData.screen_title} -{" "}
          <span className="heading-cod">
            {nonStateCostSourceAndTypeData.screenNumber}
          </span>
        </h1>
      </div>
      <SearchBox
        formFields={nonStateCostSourceAndTypeData.formFields}
        dropdownValues={nonStateCostSourceAndTypeData.dropdownValues}
        paramsData={nonStateCostSourceAndTypeData.paramsData}
        updataParamData={nonStateCostSourceAndTypeData.updateParamData}
      />
      <DisplayTable
        data={nonStateCostSourceAndTypeData.data}
        parmKey={nonStateCostSourceAndTypeData.parmKey}
        menuOptions={nonStateCostSourceAndTypeData.menuOptions}
        tableHeaders={nonStateCostSourceAndTypeData.columnDef}
        setRowData={nonStateCostSourceAndTypeData.setRowData}
        selectedPriceSchedules={nonStateCostSourceAndTypeData.selectedRows}
        setSelectedPriceSchedules={
          nonStateCostSourceAndTypeData.setSelectedRows
        }
        selectMode={true}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={nonStateCostSourceAndTypeData.first}
          rows={nonStateCostSourceAndTypeData.rows}
          totalRecords={nonStateCostSourceAndTypeData.totalRecords}
          currentPage={nonStateCostSourceAndTypeData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={nonStateCostSourceAndTypeData.onPageChange}
        />
      </div>
      {nonStateCostSourceAndTypeData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={nonStateCostSourceAndTypeData.isConfirmationModalOpen}
          onRequestClose={nonStateCostSourceAndTypeData.closeConfirmationModal}
          onBack={nonStateCostSourceAndTypeData.closeConfirmationModal}
          onSave={nonStateCostSourceAndTypeData.deletePriceSchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={nonStateCostSourceAndTypeData.setSelectedOption}
        />
      )}
    </div>
  );
};

export default NonStateCostSourceAndType;
